import useMutation from "src/hooks/useMutation";

function useProductModelRemove(productId) {
  return useMutation({
    path: `/api/v1/products/${productId}/product-models/prodModelId`,
    method: "DELETE",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/products`,
      shouldRevalidate: true,
    },
  });
}

export default useProductModelRemove;
